<template>
  <div class="home-list-page">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <span> / </span>
        <span>{{ sideMenu[activeSide] }}</span>
      </span>
    </div>
    <div class="list-layout">
      <div class="list-sidebar">
        <div class="sidebar-title">资讯列表</div>
        <div class="side-menu">
          <div v-for="(item, index) in sideMenu" :key="index"
            class="side-item" :class="{ active: activeSide === index }"
            @click="activeSide = index; currentPage = 1">{{ item }}</div>
        </div>
      </div>
      <div class="list-content">
        <div class="content-header">
          <div class="content-title">{{ sideMenu[activeSide] }}</div>
        </div>
        <div class="news-list">
          <div v-for="(group, gIndex) in pagedGroups" :key="gIndex" class="list-group">
            <div v-for="(item, index) in group" :key="index" class="news-item"
              @click="$emit('select-article', activeSide, item)">
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <span class="page-btn" @click="goFirst">首页</span>
          <span class="page-btn" @click="goPrev">上一页</span>
          <span v-for="n in totalPages" :key="n" class="page-num"
            :class="{ active: currentPage === n }" @click="currentPage = n">{{ n }}</span>
          <span class="page-btn" @click="goNext">下一页</span>
          <span class="page-btn" @click="goLast">尾页</span>
          <span class="page-info">共{{ totalPages }}页</span>
          <span class="page-jump">跳至<input type="text" v-model.number="jumpPage" class="jump-input">页<span class="jump-btn" @click="goJump">确认</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pointImg from '../assets/imgs/point.png'

export default {
  name: 'HomeList',
  props: {
    section: { type: String, default: '首页' },
    listNews: { type: Array, default: () => [] },
    listCulture: { type: Array, default: () => [] },
    listGuide: { type: Array, default: () => [] },
    listGov: { type: Array, default: () => [] },
    listConsult: { type: Array, default: () => [] },
    listScene: { type: Array, default: () => [] },
  },
  emits: ['go-home', 'select-article'],
  data() {
    const sideMap = { '景区动态': 0, '景区文化': 1, '旅游攻略': 2, '政务公开': 3, '政务信息': 4, '景区风光': 5 }
    return {
      pointImg,
      activeSide: sideMap[this.section] !== undefined ? sideMap[this.section] : 0,
      sideMenu: ['景区动态', '景区文化', '旅游攻略', '政务公开', '政务信息', '景区风光'],
      currentPage: 1,
      pageSize: 20,
      jumpPage: 1,
    }
  },
  computed: {
    currentData() {
      const map = [this.listNews, this.listCulture, this.listGuide, this.listGov, this.listConsult, this.listScene]
      return map[this.activeSide] || []
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.currentData.length / this.pageSize))
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.currentData.slice(start, start + this.pageSize)
    },
    pagedGroups() {
      const groups = []
      for (let i = 0; i < this.pagedList.length; i += 5) {
        groups.push(this.pagedList.slice(i, i + 5))
      }
      return groups
    },
  },
  methods: {
    goFirst() { this.currentPage = 1 },
    goPrev() { if (this.currentPage > 1) this.currentPage-- },
    goNext() { if (this.currentPage < this.totalPages) this.currentPage++ },
    goLast() { this.currentPage = this.totalPages },
    goJump() {
      const n = Number(this.jumpPage)
      if (n >= 1 && n <= this.totalPages) this.currentPage = n
    },
  },
}
</script>

<style scoped lang="less">
.home-list-page{
  .breadcrumb{
    padding-top: 0.2rem;
    padding-left: 0.1rem;
    padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .list-layout{
    display: flex;
    margin-top: 0.3rem;
    gap: 0.2rem;
    .list-sidebar{
      width: 3.23rem;
      flex-shrink: 0;
      .sidebar-title{
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        font-size: 0.29rem;
        color: #fff;
        background: #369BF8;
      }
      .side-menu{
        border: 1px solid #e0e0e0;
        border-top: none;
        padding: 0.2rem 0;
        .side-item{
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          color: #787A7B;
          cursor: pointer;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 0.15rem;
            right: 0.15rem;
            bottom: 0;
            height: 1px;
            background: #e0e0e0;
          }
          &:last-child::after{ display: none; }
          &.active{
            font-size: 0.27rem;
            color: #1372C9;
            gap: 0.08rem;
            &::before{
              content: '';
              width: 0;
              height: 0;
              border-top: 0.06rem solid transparent;
              border-bottom: 0.06rem solid transparent;
              border-left: 0.09rem solid #369BF8;
              flex-shrink: 0;
            }
          }
        }
      }
    }
    .list-content{
      flex: 1;
      min-width: 0;
      min-height: 10rem;
      padding: 0 0.25rem;
      .content-header{
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 0.15rem;
        .content-title{
          display: inline-block;
          font-size: 0.27rem;
          color: #1372C9;
          border-bottom: 2px solid #1372C9;
          padding-bottom: 0.02rem;
          margin-bottom: -1px;
        }
      }
      .news-list{
        .list-group{
          margin-bottom: 0.15rem;
          &:last-child{ margin-bottom: 0; }
        }
        .news-item{
          display: flex;
          align-items: center;
          padding: 0.1rem 0.3rem 0.1rem 0;
          cursor: pointer;
          &:hover{ background: rgba(0,0,0,.03); }
          .news-dot{
            width: 0.05rem;
            height: 0.05rem;
            border-radius: 50%;
            background: #0E8064;
            flex-shrink: 0;
            margin-right: 0.1rem;
          }
          .news-title{
            flex: 1;
            min-width: 0;
            font-size: 0.19rem;
            color: #2C2C2C;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 0.2rem;
          }
          .news-date{
            font-size: 0.19rem;
            color: #989898;
            flex-shrink: 0;
          }
        }
      }
      .pagination{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.05rem;
        margin: 0.4rem;
        flex-wrap: wrap;
        .page-btn, .page-num, .jump-btn{
          padding: 0.05rem 0.12rem;
          border: 1px solid #d9d9d9;
          font-size: 0.16rem;
          color: #333;
          cursor: pointer;
          user-select: none;
          background: #fff;
          &:hover{
            border-color: #369BF8;
            color: #369BF8;
          }
        }
        .page-num.active{
          background: #369BF8;
          color: #fff;
          border-color: #369BF8;
        }
        .page-info{
          font-size: 0.16rem;
          color: #666;
          margin-left: 0.1rem;
        }
        .page-jump{
          font-size: 0.16rem;
          color: #666;
          margin-left: 0.1rem;
          .jump-input{
            width: 0.5rem;
            height: 0.25rem;
            border: 1px solid #d9d9d9;
            text-align: center;
            font-size: 0.16rem;
            margin: 0 0.05rem;
            outline: none;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button{
              -webkit-appearance: none;
            }
          }
          .jump-btn{
            margin-left: 0.05rem;
          }
        }
      }
    }
  }
}
</style>
